import React from "react";
import { MyCheckbox } from "components";
import { useFormik } from "formik";
import { InputField } from "components";
const ChargeTypesBody = ({ type }) => {
  const formik = useFormik({
    initialValues: {},
  });
  const exceptThisSymbols = ["e", "E", "+", "-"];

  const preventArrows = (e) => {
    if (e.which === 38 || e.which === 40 || exceptThisSymbols.includes(e.key))
      e.preventDefault();
  };
  return (
    <div>
      <div className="input-fields addnew-fields">
        <div className="billing-amount-details charge-type-fields mt-10">
          <div className="col-sm-5 position-relative disabled-action billing-input-field pb-2 ml-5 mr-5">
            <InputField
              type="text"
              {...{
                formik,
                title: "Parent ",
                name: `Parent `,
                placeholder: "Donations",
              }}
              style={{
                border: "1px solid #B5B5C3",
                backgroundColor: "#E7E7EB",
              }}
            />{" "}
          </div>
          <div className="col-sm-5 disabled-action position-relative billing-input-field charge-dollar-sign pb-2 ml-5">
            <InputField
              type="number"
              {...{
                formik,
                title: " Default Amount",
                name: ``,
                placeholder: "200.00",
              }}
              onKeyDown={(e) => preventArrows(e)}
              style={{
                border: "1px solid #B5B5C3",
                backgroundColor: "#E7E7EB",
              }}
              // handleChange={(e) => {
              //   formik.setFieldValue(
              //     `batch_billing_amount`,
              //     e.target.value.match(regex)[0]
              //   );
              // }}
            />
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="14"
                height="14"
                fill="currentColor"
                class="bi bi-currency-dollar"
                viewBox="0 0 16 16"
              >
                <path d="M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z" />
              </svg>
            </span>
          </div>
        </div>

        <div className="input-second-row billing-amount-details">
          <div className="col-sm-12 position-relative billing-input-field charge-dollar-sign pb-2 ml-1 col-md-4">
            <div className="col-md-11 disabled-action col-sm-6">
              <InputField
                type="number"
                {...{
                  formik,
                  title: " Amount Deductible ",
                  name: `Amount Deductible `,
                  placeholder: "2",
                }}
                onKeyDown={(e) => preventArrows(e)}
                style={{
                  border: "1px solid #B5B5C3",
                  backgroundColor: "#E7E7EB",
                }}
              />
              <span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="14"
                  height="14"
                  fill="currentColor"
                  class="bi bi-percent"
                  viewBox="0 0 16 16"
                >
                  <path d="M13.442 2.558a.625.625 0 0 1 0 .884l-10 10a.625.625 0 1 1-.884-.884l10-10a.625.625 0 0 1 .884 0zM4.5 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5zm7 6a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3zm0 1a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z" />
                </svg>
              </span>
            </div>
          </div>
          <div className="col-sm-12 position-relative billing-input-field gateway-fee pb-2 offset-md-1  col-md-5 col-sm-12">
            <div className="col-md-9 disabled-action ml-10 col-sm-6">
              <InputField
                type="number"
                {...{
                  formik,
                  title: "Gateway Fee Override ",
                  name: `Gateway Fee Override `,
                  placeholder: "None",
                }}
                onKeyDown={(e) => preventArrows(e)}
                style={{
                  border: "1px solid #B5B5C3",
                  backgroundColor: "#E7E7EB",
                }}
              />{" "}
            </div>
          </div>
        </div>

        <div className="d-flex  pl-5 ml-5 pt-5 mt-5">
          <div className="m-0 disabled-action type-check-box pr-5 mr-5">
            <MyCheckbox
              name={`donation`}
              title="Donation"
              handlechange={(event) => {
                formik.setFieldValue("donation", event.target.checked);
              }}
              checked={formik.values?.donation}
              value={formik.values?.donation}
            />
          </div>
          <div className="m-0 disabled-action type-check-box pl-5 ml-5">
            <MyCheckbox
              name={`require_notes`}
              title="Require Notes"
              handlechange={(event) => {
                formik.setFieldValue("require_notes", event.target.checked);
              }}
              checked={formik.values?.require_notes}
              value={formik.values?.require_notes}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChargeTypesBody;
